export enum TimeParameter {
  INJECTION_RATE = "injection_rate",
  INJECTION_TIME = "injection_time",
}
